<script>
  import Button from '@components/buttons/button.svelte'
  import { page, router } from '@inertiajs/svelte'
  import { CalendarCheck, CalendarX } from 'lucide-svelte'

  let user = $derived($page.props.user)
  let autoEnroll = $derived(user?.auto_enroll_live_sessions)

  let hint = $derived.by(() => {
    if (user.is_admin) return 'Auto-enroll is only available for members'
    return null
  })

  function toggle() {
    const action = autoEnroll ? 'disable' : 'enable'
    if (!confirm(`Are you sure you want to ${action} auto-enroll for live sessions?`)) return
    router.patch('/settings/profile', { auto_enroll_live_sessions: !autoEnroll }, { preserveScroll: true })
  }
</script>

<Button
  variant={autoEnroll ? 'primary' : 'outline'}
  size="sm"
  text={autoEnroll ? 'Auto-enroll on' : 'Auto-enroll off'}
  Icon={autoEnroll ? CalendarCheck : CalendarX}
  onclick={toggle}
  disabled={user.is_admin}
  {hint}
  tooltipProps={{ side: "left" }}
  class={!autoEnroll ? 'opacity-70 hover:opacity-100' : ''}
/>
